'use strict'

exports.defined = function (val) {
  return val !== null && val !== undefined && (typeof val !== 'number' || !isNaN(val))
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/protons/src/compile/utils.js
// module id = AW9o
// module chunks = 0